import {
  PressP,
  PressI,
  PressJ,
  PressC,
  PressS,
  PressM,
  PressV,
  PressZ,
} from 'assets';

export const histories = [{
  date: '2022.06.',
  content: '데이트팝 누적 다운로드 500만 돌파'
},{
  date: '2021.08.',
  content: '데이트팝 누적 다운로드 460만, 누적 제휴점 2000개 돌파'
},{
  date: '2021.07.',
  content: '서울관광재단 관광벤처기업 선정'
}, {
  date: '2020.02.',
  content: '데이트팝 누적 다운로드 400만, 누적 제휴점 2000개 돌파'
}, {
  date: '2018.07.',
  content: '투자 유치 23억 (대성창투, 쿨리지코너, 에트리홀딩스)'
}, {
  date: '2016.07.',
  content: '전국 5대 광역시 통합 ‘데이트팝’ 출시'
}, {
  date: '2016.04.',
  content: '포스코기술투자(주)로부터 10억 투자 유치'
}, {
  date: '2014.08.',
  content: '투자연계형멘토링 R&D사업 선정 – 연구비 2억 유치'
}, {
  date: '2014.07.',
  content: '쿨리지코너 인베스트먼트(주)로부터 4억 투자 유치'
}, {
  date: '2014.04.',
  content: '(주)텐핑거스 법인 설립. (대표이사 : 신동해)'
}, {
  date: '2013.09.',
  content: '서울데이트팝 앱 런칭'
}, {
  date: '2013.07.',
  content: '창업맞춤형사업 투자연계형 선정'
}];

export const contests = [{
  date: '2015.03.',
  content: '대한민국 모바일 어워드 2015 ‘3월 으뜸앱’'
}, {
  date: '2014.05.',
  content: '제4회 창조관광사업 공모전 우수상'
}, {
  date: '2013.11.',
  content: '제1회 공공데이터 활용 창업경진대회 우수상'
}];

export const companyProfiles = [{
  imgUrl: 'https://storage.googleapis.com/seouldatepop/homepage_profile/ceo_company_01.jpg',
}, {
  imgUrl: 'https://storage.googleapis.com/seouldatepop/homepage_profile/ceo_company_02.jpg',
}, {
  imgUrl: 'https://storage.googleapis.com/seouldatepop/homepage_profile/ceo_company_03.jpg',
}];

export const news = [{
  url: 'http://platum.kr/archives/58723',
  title: '데이트팝 운영사 ‘텐핑거스’, 포스코기술투자로부터 10억원 투자 유치',
  content: '2030 커플들을 위한 데이트 코스 추천 앱 ‘데이트팝’을 운영하는 텐핑거스는 포스코기술투자㈜ 로부터 10억원을 투자 유치했다고 26일 밝혔다. 쿨리지코너인베스트먼트로부터...',
  date: '2017.01.03',
  press: '플래텀',
  img: PressP,
}, {
  url: 'http://www.koreaittimes.com/news/articleView.html?idxno=59828',
  title: '공공데이터를 활용한 스타트업계의 혁신 아이템',
  content: '서울데이트팝은 한국관광공사 투어API 2.0을 활용해 20~30대 커플들에게 지역별, 테마별 데이트 코스를 안내해주는 서비스다. 앱 다운로드만 100만 건을 넘었고, 네이버...',
  date: '2016.12.05',
  press: 'Korea IT TIMES',
  img: PressI,
}, {
  url: 'http://www.etnews.com/20140721000259',
  title: '쿨리지코너인베스트먼트, `서울데이트팝` 텐핑거스에 4억원 투자',
  content: '서울데이트팝은 20~30대 커플에게 지역별 데이트코스를 추천하는 모바일 서비스다. 현재까지는 대부분 블로그나 맛집 소개 등 각각의 장소를 소개하는 서비스가..',
  date: '2014.07.21',
  press: '전자신문',
  img: PressJ,
}, {
  url: 'http://biz.chosun.com/site/data/html_dir/2015/10/22/2015102202879.html',
  title: "[오늘의 앱] 데이트코스에 골머리 앓는다면…'서울데이트팝'",
  content: "텐핑거스가 내놓은 앱 '서울데이트팝'은 대중의 경험을 한데 모아 이러한 바람을 해결했다. 이 앱은 20~30대 커플에게 데이트코스를 추천한다. 추천 방식은 '스토리텔링'이다. 특정 장소가...",
  date: '2015.10.23',
  press: '조선비즈',
  img: PressC,
}, {
  url: 'http://www.mt.co.kr/view/mtview.php?type=1&no=2016072708215228298&outlink=1',
  title: "데이트 고민? '데이트팝'에서 해결하세요",
  content: "제2의 벤처붐을 조성하기 위해 개설된 국내 최초 모바일 서비스 전문 시상식인 '대한민국 모바일 어워드'(매월 우수 모바일 선정)가 올해로 7회를 맞았다. 2010∼2015년 6년간 수상기업은 180여개사...",
  date: '2016.08.03',
  press: '머니투데이',
  img: PressM,
}, {
  url: 'http://news.mt.co.kr/mtview.php?no=2017012010521047413',
  title: '데이트팝, 팝동여지도 공개… 데이트 명소 50곳 엄선',
  content: "데이트팝의 2030 커플들의 데이터에 기반한 '2017 팝동여지도 베스트 50'(이하 팝동여지도)를 공개했다고 20일 밝혔다. 팝동여지도는 데이트팝 사용자 100만명의 조회 수, '찜하기'(즐겨찾기)...",
  date: '2017.01.20',
  press: '머니투데이',
  img: PressM,
}, {
  url: 'http://www.sedaily.com/NewsView/1S3GJBDRQM',
  title: '텐핑거스, 23억원 투자유치 성공',
  content: "[월 사용자 120만명 기록 | 제휴점 재계약률 75% 넘어 | 준수한 광고수익 창출해] 데이트코스 추천서비스 ‘데이트팝’을 운영하는 텐핑거스가 23억원 투자유치에 성공했다. 이번 투자에는 대성창업투자...",
  date: '2018.08.22',
  press: '서울경제',
  img: PressS,
}, {
  url: 'http://www.venturesquare.net/768032',
  title: "지금 데이트하고 있나요 '데이트팝'",
  content: "신 대표는 “놀이 영역이 하나의 문화로 자리잡고 있고 관련시장도 커지고 있다”며 “새로운 트렌드와 변화가 맞물리는 상황에서 데이트팝은 믿을 수 있는 놀거리 광고 플랫폼으로 성장할 것”이라고 포부를 밝혔다...",
  date: '2018.09.05',
  press: '벤처스퀘어',
  img: PressV,
}, {
  url: 'https://www.zdnet.co.kr/view/?no=20190314103145',
  title: "신동해 텐핑거스 \"데이트팝, 커플과 이색 데이트 장소의 연결고리\"",
  content: "\"데이트팝은 이색 데이트 장소를 즐겨 찾는 커플들과 자영업자를 연결해주는 실용적인 앱이다. 커플은 데이트 장소에 고민을 덜고, 자영업자는 마케팅에 부담을 줄여주는 게 핵심이다.\"신동해 텐핑거스 대표는 지난 12일 기자와 만나 \"데이트팝은 이색 장소를 원하는 커플을 위한 필수 데이트앱\"이라며 이 같이 말했다...",
  date: '2019-03-14',
  press: '지디넷코리아',
  img: PressZ,
}, {
  url: 'https://biz.chosun.com/site/data/html_dir/2020/04/12/2020041201096.html?utm_source=naver&utm_medium=original&utm_campaign=biz',
  title: "美 포브스 선정 '亞 300인 리더'에 韓 스타트업 대표 21명",
  content: "중소벤처기업부는 지난 1일(현지시각) 미국 포브스사가 선정한 '2020년 아시아 글로벌 리더 300인'에 한국의 청년 스타트업 최고경영자(CEO) 21인이 선정됐다고 12일 밝혔다...",
  date: '2020-04-12',
  press: '비즈조선',
  img: PressC,
}];